<template>
	<SectionCard
		title="Controlli prima della dichiarazione"
		icon="mdi-clipboard-check-outline"
		:subtitle="total ? `${formatNumber(total)} da guardare` : 'tutto in ordine'"
		no-padding
		data-tour="checks"
	>
		<div v-if="total" class="fo-chips pa-3">
			<v-chip v-for="c in counts" :key="c.type" small label :outlined="filter !== c.type" color="primary" @click="filter = filter === c.type ? '' : c.type">
				{{ c.label }}: {{ formatNumber(c.count) }}
			</v-chip>
		</div>
		<v-simple-table dense>
			<thead>
				<tr>
					<th>Controllo</th>
					<th>Ordine</th>
					<th>Canale</th>
					<th>Paese</th>
					<th>Dettaglio</th>
					<th style="width: 44px"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(i, n) in rows" :key="n">
					<td>
						<div>{{ issue(i.type).label }}</div>
						<div class="fo-muted">{{ issue(i.type).hint }}</div>
					</td>
					<td class="fo-code">{{ i.OrderID || '—' }}</td>
					<td>{{ sourceName(i.platform) }}</td>
					<td>{{ i.country || '—' }}</td>
					<td class="fo-code">{{ i.note || '' }}</td>
					<td>
						<v-menu offset-y left>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon small v-bind="attrs" title="Azioni" v-on="on"><v-icon small>mdi-dots-vertical</v-icon></v-btn>
							</template>
							<v-list dense>
								<v-list-item link @click="$emit('open-order', i)">
									<v-list-item-title>Apri l’ordine</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</td>
				</tr>
				<tr v-if="!rows.length">
					<td colspan="6" class="text-center grey--text py-4">{{ total ? 'Nessun ordine con questo controllo fra quelli mostrati.' : 'Nessun problema trovato negli ordini del periodo.' }}</td>
				</tr>
			</tbody>
		</v-simple-table>
		<div v-if="total > report.issues.length" class="fo-muted pa-3">Elenco limitato ai primi {{ report.issues.length }} ordini: i conteggi in alto sono completi.</div>
		<div v-if="report.issueCount.reducedRate" class="fo-muted pa-3">
			{{ formatNumber(report.issueCount.reducedRate) }} righe OSS hanno un’aliquota ridotta: il Paese potrebbe applicarne una diversa per quella merce. Le correzioni si fanno nelle impostazioni.
		</div>
	</SectionCard>
</template>

<script>
import SectionCard from '@/components/core/SectionCard.vue';
import { formatNumber, sourceName } from '@/components/finance/format';
import { ISSUES } from './labels';

export default {
	name: 'ForeignChecks',
	components: { SectionCard },
	props: {
		report: { type: Object, required: true },
	},
	data() {
		return { filter: '' };
	},
	computed: {
		// le aliquote ridotte sono righe, non ordini: hanno la loro nota sotto la tabella
		counts() {
			return Object.entries(this.report.issueCount || {})
				.filter(([type]) => type !== 'reducedRate')
				.map(([type, count]) => ({ type, count, label: (ISSUES[type] || { label: type }).label }))
				.sort((a, b) => b.count - a.count);
		},
		total() {
			return this.counts.reduce((t, c) => t + c.count, 0);
		},
		rows() {
			return (this.report.issues || []).filter(i => !this.filter || i.type === this.filter);
		},
	},
	methods: {
		formatNumber,
		sourceName,
		issue: type => ISSUES[type] || { label: type, hint: '' },
	},
};
</script>

<style scoped>
.fo-chips {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}
.fo-code {
	font-family: monospace;
	font-size: 12px;
	color: #5f6b7a;
}
.fo-muted {
	font-size: 12px;
	color: #5f6b7a;
}
</style>
